import {
  PAYMENT_METHOD_CONFIG,
  type PaymentMethodConfig
} from '../pages/register/RegisterScreen/constants/payment-method.const';

/**
 * Maps backend payment brand keys to the canonical {@link PAYMENT_METHOD_CONFIG}.
 *
 * Brand keys come lower-cased from the API — they may be:
 *   - `payment_consent.card_brand` for cards: "visa", "mastercard", "amex", "unionpay"
 *   - `payment_consent.method` for e-wallets: "tng-ewallet", "tng", "grabpay", "shopeepay", "duitnow"
 *
 * Multiple backend values can point to the same config (e.g. "tng-ewallet" and "tng" → tng).
 */
const BACKEND_BRAND_TO_CONFIG_KEY: Record<
  string,
  keyof typeof PAYMENT_METHOD_CONFIG
> = {
  // Cards
  visa: 'visa',
  mastercard: 'mastercard',
  amex: 'amex',
  unionpay: 'unionpay',

  // E-wallets — multiple keys can map to the same config
  'tng-ewallet': 'tng',
  'tng-e-wallet': 'tng',
  tng: 'tng',
  grabpay: 'grabpay',
  shopeepay: 'shopeepay'
};

/**
 * Resolve the payment method config (label + logo) for a backend brand key.
 * Returns `null` if the brand is not recognized.
 */
export const resolvePaymentMethodConfig = (
  brand?: string | null
): PaymentMethodConfig | null => {
  if (!brand) return null;
  const configKey = BACKEND_BRAND_TO_CONFIG_KEY[brand.toLowerCase()];
  if (!configKey) return null;
  return PAYMENT_METHOD_CONFIG[configKey] ?? null;
};
